<template>
  <div class="background-modal align-modal" id="outModal">
    <div class="content">
      <div class="header"> 
        <div id="header-row">
          <p id="header-title">Detalhes do contato</p>
          <i class="fas fa-times" id="close-button" @click="dismissModal"></i>
        </div>
      </div>
      <div class="body">
        <div id="img-container">
          <img src="/imgs/default-profile.png">
        </div>
        <div id="details-container">
          <div class="custom-input-group">
            <label for="name">Nome</label>
            <input type="text" class="form-control" name="name" id="name" v-model="updateData.name" required :disabled="disable">
          </div>
          <div class="custom-input-group">
            <label for="phone">Telefone</label>
            <input 
              type="text" 
              class="form-control campoTel" 
              pattern="\d+" 
              name="phone" 
              id="vlTel1" 
              v-model="updateData.phone"  
              v-mask="['(##) ####-####', '(##) #####-####']"
              placeholder="(11) 9XXXX-XXXX"
              maxlength="15" 
              required 
              :disabled="disable"
            >
          </div>

          <div class="custom-input-group" v-if="lengthTipo > 0">
            <label for="contactStatus">Tipo</label>
            <select class="form-control" name="contactStatus" id="contactStatus" v-model="updateData.status" :disabled="disable">
              <option value="" selected disabled>Selecione...</option>
              <option v-for="(value, key) in select_tipo" :key="key" :value="value.id">{{ value.name }}</option>
            </select>
          </div>

          <div class="custom-input-group" v-if="lengthFilter > 0 && updateData.status == 2">
            <label for="contactEmpresa">Empresa</label>
              <input 
                class="form-control" 
                name="contactNamePaciente" 
                type="text" 
                v-model="updateData.empresa" 
                placeholder="Insira o nome da empresa" 
                :disabled="disable"
                >
          </div>

          <div class="custom-input-group" v-if="lengthFilter > 0 && updateData.status == 2">
            <label for="contactEmail">E-mail</label>
              <input 
                class="form-control" 
                name="contactNamePaciente" 
                type="text" 
                v-model="updateData.email" 
                placeholder="Insira o E-mail" 
                @blur="validateEmail"
                :disabled="disable"
              >
                    
              <p class="mt-2" v-if="updateData.email && !emailValid" style="color: red;">
                Por favor, insira um e-mail válido.
              </p>
          </div>

          <div class="custom-input-group" v-if="lengthFilter > 0 && updateData.status == 2">
            <label for="contactFilter">Filtro</label>
            <select class="form-control" name="contactFilter" id="contactFilter" v-model="updateData.filter" :disabled="disable">
              <option value="" selected  disabled>Selecione...</option>
              <option v-for="(value, key) in select_filter" :key="key" :value="value.id">{{ value.name }}</option>
            </select>
          </div>

          <div class="custom-input-group">
            <label for="cnpj">ID/CNPJ/CPF</label>
            <input
              type="text"
              class="form-control"
              name="chave-unica"
              id="chave-unica"
              v-model="updateData.unique_key"
              :placeholder="placeholder"
              :disabled="disable"
              @input="handleInput"
            >
          </div>

          <div class="custom-input-group">
            <label for="group">Grupo</label>
            <input
              type="text"
              class="form-control"
              name="group"
              id="group"
              v-model="updateData.group"
              :disabled="disable"
            >
          </div>

        </div>
      </div>
      <div>
        <div id="button-group">
          <button type="button" :hidden="disable"  @click="updateCl" class="btn btn-success cursor-pointer" id="btn-save"><i class="fa fa-save"></i>    Salvar</button>
          <button type="button" :hidden="disable"  @click="deleteCl" class="btn btn-danger cursor-pointer" id="btn-delete"><i class="fa fa-trash"></i>    Excluir</button>
          <button type="button" :hidden="!disable" @click="enableEdit" class="btn btn-info cursor-pointer" id="btn-edit"><i class="fa fa-edit"></i>    Editar</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  props:{
      data:{
        type: Object
      }
  },
  data(){
    return {
      show: true,
      arquivos: [],
      disable: true,
      updateData:{
        name: this.data.name,
        phone: this.data.phone,
        group: this.data.wallet_group,
        unique_key: this.data.unique_key,
        empresa: this.data.company_name,
        email: this.data.email,
        status: this.data.type_id.id,
        filter: this.data.filter.id,
      },
      select_tipo: [],
      lengthTipo: 0,
      select_filter: [],
      lengthFilter: 0,
      placeholder: 'XX.XXX.XXX-XX',    
      emailValid: true
    }
  },
  created(){
    axios.get('/new-screen/show').then(data => this.arquivos = data.data);
    this.getTipos();
    this.getFilters();
  },
  mounted(){
    this.$el.addEventListener('click', this.onClick);
    document.addEventListener('keyup', this.onClick);
  },
  destroyed() {
    this.$el.removeEventListener('click', this.onClick);
    document.removeEventListener('keyup', this.onClick);
  },
  methods:{
    handleInput() {
      const value = this.updateData.unique_key.replace(/\D/g, '').slice(0, 14);

      if (value.length === 11) {
        this.placeholder = 'CPF';
        this.$set(this.updateData, 'unique_key', value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'));
      } else if (value.length === 14) {
        this.placeholder = 'CNPJ';
        this.$set(this.updateData, 'unique_key', value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'));
      }
    },
    validateEmail() {
      if (!this.updateData.email) {
          this.emailValid = true;
          return;
      }

      const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      this.emailValid = emailPattern.test(this.updateData.email);
    },
    enableEdit(){
      this.disable = !this.disable
    },
    dismissModal(){
      this.$emit('dismissModal');
    },
    deleteCl(){
      axios.post('/customer_base/destroy', {id: this.data.id}).then(data => {
        Swal.fire(
          'Registro Excluído',
          'Este cliente não faz mais parte de sua base',
          'success'
        ).then((confirm) => {
          this.dismissModal();
        });
      });
    },
    checkForm: function(){
        if (this.updateData.name == null || this.updateData.name == ''){
            Swal.fire({
                html: 'O campo "Nome" não foi preenchido!',
                type: "warning",
                showCloseButton: true,
                confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
            });
            return false  
        }
        if(this.updateData.status == 1 || this.updateData.status == ''){
                Swal.fire({
                    html: 'O campo "Tipo" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false  
        }
        if(this.updateData.status == 2 && this.updateData.filter == 1 || this.updateData.filter == ''){
            Swal.fire({
                html: 'O campo "Filtro" não foi preenchido!',
                type: "warning",
                showCloseButton: true,
                confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
            });
            return false  
        }
        if (this.updateData.phone == null || this.updateData.phone == ''){
            Swal.fire({
                html: 'O campo "Telefone" não foi preenchido!',
                type: "warning",
                showCloseButton: true,
                confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
            });
            return false  
        }
        if(this.updateData.phone.length == 14 || this.updateData.phone.length == 15){
            return true
        }else{
            return false
        }
    },
    updateCl(){
      if(this.checkForm()){
        this.updateData.phone = this.updateData.phone ? this.updateData.phone.replace(/\D/g,'') : '';
        this.updateData.unique_key = this.updateData.unique_key ? this.updateData.unique_key.replace(/\D/g,'') : '';
        axios.post('/customer_base/save', {
          id: this.data.id,
          name: this.updateData.name,
          phone: this.updateData.phone,
          wallet_group: this.updateData.group,
          company_name: this.updateData.empresa,
          email: this.updateData.email,
          unique_key: this.updateData.unique_key,
          filter: this.updateData.filter,
          type_id: this.updateData.status,
        }).then(data => {
          Swal.fire(
            'Atualização realizada',
            'Os dados deste cliente foram atualizados',
            'success'
          ).then((confirm) => {
            this.dismissModal();
          });
        });
      }
    },
    getTipos (){
      axios.get('dialer/contatos/getTipoContato').then(({data}) => {
        this.lengthTipo = data.length;
        this.select_tipo = data.filter(type => type.id !== 1);
      });
    },
    getFilters() {
      axios.get('dialer/contatos/getFilterContato').then(({data}) => {
        this.lengthFilter = data.length;
        this.select_filter = data.filter(filter => filter.id !== 1);
      })
    },
  },

}
</script>

<style scoped>

.background-modal{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color:rgba(125,125,125, 0.5);
}

.align-modal{
  display:flex;
  align-items: center;
  justify-content: center;
}

#header-row{
  display: flex;
  justify-content: space-between;
  background-color: #1c869a;
  border-top: 3px solid #f38630;
}

#header-title{
  color: white;
  font-weight: bold;
  margin: 5px 20px;
  align-self: center;
}

#close-button{
  font-weight: bolder;
  background-color: white;
  color: #aa1a1a;
  cursor: pointer;
  border: 1px solid #aa1a1a;
  border-radius: 10px !important;
  padding: 8px;
  align-self: center;
  margin: 5px;
}

#close-button:hover{
  background-color: #aa1a1a;
  color: white;
  transition: 0.5s;
  border: 1px solid white;
}

.content{
  background-color: #fff;
  width: 35em;
  border-radius: 15px;
  overflow: auto;
}

.body{
  display:flex;
  flex-flow: row wrap;
  overflow: auto;
  justify-content: center;
}
.row {
  width: 100%;
}

.body img{
    border-radius: 50%;
    height: 7em;
    border: 5px solid #1c869a66;
}

#img-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px;
}

#details-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10px
}

.custom-input-group {
  padding: 10px;
}

.custom-input-group label {
  align-self: center;
  font-weight: bold;
}

#btn-save {
  color: white;
  background-color: #034103;
  border: 3px solid white;
  border-radius: 10px !important;
}

#btn-save:hover {
  color: #034103;
  background-color: white;
  border: 3px solid #034103;
  border-radius: 10px !important;
  transition: 0.5s;
}

#btn-delete {
  color: white;
  background-color: #aa1a1a;
  border: 3px solid white;
  border-radius: 10px !important;
}

#btn-delete:hover {
  color: #aa1a1a;
  background-color: white;
  border: 3px solid #aa1a1a;
  border-radius: 10px !important;
  transition: 0.5s;
}

#btn-edit {
  color: white;
  background-color: #0e0e69;
  border: 3px solid white;
  border-radius: 10px !important;
}

#btn-edit:hover {
  color: #0e0e69;
  background-color: white;
  border: 3px solid #0e0e69;
  border-radius: 10px !important;
  transition: 0.5s;
}

#button-group {
  display: flex;
  justify-content: flex-end;
  margin: 10px 20px;
}

</style>